module.exports = __webpack_public_path__ + "static/media/i-stock.35e93941.png";